<template>
  <div>
    <v-alert
      type="info"
      dense
      outlined
      border="left"
      class="mb-3"
    >
      Catálogo somente leitura. As permissões disponíveis são definidas pelo back-end.
    </v-alert>

    <v-progress-linear
      v-if="loading"
      indeterminate
      color="secondary"
      class="mb-3"
    />

    <v-text-field
      v-model="search"
      label="Filtrar"
      prepend-inner-icon="mdi-magnify"
      outlined
      dense
      clearable
      hide-details
      class="mb-3"
    />

    <v-expansion-panels
      multiple
      accordion
      flat
    >
      <v-expansion-panel
        v-for="grupo in filteredGroups"
        :key="grupo.key"
      >
        <v-expansion-panel-header>
          <div class="d-flex align-center">
            <v-icon
              small
              color="secondary"
              class="mr-2"
            >
              {{ grupo.icon }}
            </v-icon>
            <span class="text-subtitle-2">{{ grupo.label }}</span>
            <v-spacer />
            <v-chip
              x-small
              outlined
            >
              {{ grupo.permissoes.length }}
            </v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="grupo.permissoes"
            item-key="id"
            dense
            hide-default-footer
            :items-per-page="-1"
          >
            <template #item.chave="{ item }">
              <code>{{ item.chave }}</code>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-alert
      v-if="!loading && !filteredGroups.length"
      type="warning"
      dense
      outlined
      border="left"
    >
      Nenhuma permissão encontrada.
    </v-alert>
  </div>
</template>

<script>
  import { $k } from '@/lib/kraken'

  const GROUP_META = {
    organizacao: { label: 'Organização', icon: 'mdi-office-building-outline' },
    agendamento: { label: 'Agendamento', icon: 'mdi-calendar-clock' },
    paciente: { label: 'Paciente', icon: 'mdi-account-injury-outline' },
    faturamento: { label: 'Faturamento', icon: 'mdi-cash-multiple' },
    relatorios: { label: 'Relatórios', icon: 'mdi-file-chart-outline' },
  }

  export default {
    name: 'PermissionsCatalogSection',

    data: () => ({
      loading: false,
      catalog: [],
      search: '',
      headers: [
        { text: 'ID', value: 'id', width: 80 },
        { text: 'Chave', value: 'chave', width: 280 },
        { text: 'Descrição', value: 'descricao' },
      ],
    }),

    computed: {
      filteredGroups () {
        const term = (this.search || '').trim().toLowerCase()
        const groups = {}
        for (const perm of this.catalog) {
          if (term && !perm.chave.toLowerCase().includes(term) && !perm.descricao.toLowerCase().includes(term)) {
            continue
          }
          const key = perm.grupo
          if (!groups[key]) {
            const meta = GROUP_META[key] || { label: key, icon: 'mdi-shield-outline' }
            groups[key] = { key, label: meta.label, icon: meta.icon, permissoes: [] }
          }
          groups[key].permissoes.push(perm)
        }
        return Object.values(groups).sort((a, b) => a.label.localeCompare(b.label))
      },
    },

    mounted () {
      this.load()
    },

    methods: {
      async load () {
        this.loading = true
        try {
          const res = await $k.manage.clinic_one.permissions.get({})
          this.catalog = res.results || []
        } catch (err) {
          console.error('[permissions.get]', err)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
